import { noop } from "@silo/utils";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
import { useSiloWeb3 } from "../SiloWeb3Provider";
import { Modal, SiloLogo } from "@silo/ui";
import { useQueryRestrictions } from "./use-query-restrictions";

export const Blocked = () => {
  const router = useRouter();
  const { accountV2 } = useSiloWeb3();
  const { data, status } = useQueryRestrictions(accountV2);

  useEffect(() => {
    if (status === "success" && data && !data.isBlocked) {
      router.replace("/");
    }
  }, [data, status, router]);

  const headingRef = useRef<HTMLHeadingElement>(null);

  return (
    <Modal
      isOpen={true}
      closeModal={noop}
      variant="transparent"
      notDismissable
      initialFocus={headingRef}
    >
      <div className="flex flex-col gap-6">
        <div>
          <SiloLogo />
        </div>

        <h1
          className="text-xl font-medium outline-none"
          tabIndex={-1}
          ref={headingRef}
        >
          Restricted access
        </h1>

        <p>
          Your wallet address appears on the OFAC list of sanctioned addresses
          and is restricted from using the Silo app.
        </p>
      </div>
    </Modal>
  );
};
